<template>
  <div>
    <b-row>
      <b-col class="col-12 text-center">
        <img src="@/assets/images/temporary/43.png">
      </b-col>

      <b-col class="mt-5 col-12 text-center">

        <b-button
          variant="primary"
          @click="myRedirectBack()"
        >
          <span>ยกเลิก</span>
        </b-button>

        <b-button
          class="ml-2"
          variant="primary"
          @click="myRedirect()"
        >
          <span>ยืนยัน</span>
        </b-button>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
  },
  methods: {

    myRedirect() {
      const routeData = this.$router.resolve({ name: 'RequestConfirm' })
      window.open(routeData.href, '_self')
    },

    myRedirectBack() {
      const routeData = this.$router.resolve({ name: 'ScreeningManage', query: { id: 1 } })
      window.open(routeData.href, '_self')
    },
  },
}
</script>

 <style lang="scss" >

</style>
